<template>
<v-content class="fill-height"  style="background: #CFD8DC">
	<Toolbar/>
	<router-view></router-view>

	<!-- <Notification /> -->
	<v-snackbar
		:timeout="alert.timeout"
		:color="alert.color"
		v-model="alert.show">
			{{ alert.message }}
	</v-snackbar>

</v-content>
</template>

<script>
	import { mapState } from 'vuex';
	export default {
		name: 'AdminDashboard',
		components: {
			Toolbar: () => import('@/components/admin/Toolbar.vue'),
		},
		computed: {
			...mapState(['alert']),
		}
		
	}
</script>

<style lang="scss" scoped>

</style>